import { useMemo } from 'react';

const useNow = () => useMemo(() => Date.now(), []);

export { useNow };
//# sourceMappingURL=useNow.mjs.map
